import { Injectable, inject } from '@angular/core';
import { SysEnum } from '@api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class IbpdiHelperService {
  private translateService = inject(TranslateService);

  /**
   * @param sysEnum<SysEnum> that includes sysEnumTranslations
   * @returns translated label
   */
  public getTranslatedEnumLable(sysEnum: SysEnum) {
    return (
      sysEnum?.sysEnumTranslation?.find(s => s.language === this.translateService.currentLang)
        ?.name ||
      sysEnum?.defaultName ||
      '--'
    );
  }
}
